<div class="back-button-container">
  <button (click)="cancelUserCreation()" class="btn btn-secondary" type="button">
    {{ 'Back' | translate }}
  </button>
</div>

<h1>
  <a class="home-link" [routerLink]="['/' + getHomePath()]">
    <i class="fa fa-home" aria-hidden="true"></i>
    <span>
      @if(isCreateMode()){
        {{ 'Create new user' | translate }}
      }
      @else {
        {{ 'Edit user' | translate }}
      }
    </span>
  </a>
</h1>

<div class="overview-styling">
  <div *ngIf="loading" class="ajax_loading_wrapper">
    <div class="ajax_loading"></div>
  </div>

  <div class="container-content" fxLayout fxLayoutAlign="space-between start">
    <form [formGroup]="userForm" class="ng" fxLayout="column" fxFlex novalidate
          (ngSubmit)="save(userForm.getRawValue())">

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{ 'Status' | translate }}
        </label>
        <div class="input-container" fxLayout="column" fxLayout.xs="column" fxFlex="70">
          <label for="active">
            <input
              id="active"
              type="checkbox"
              class="checkbox"
              name="active"
              formControlName="active"> {{ 'active' | translate }}
          </label>
          <label for="confirm">
            <input
              id="confirm"
              type="checkbox"
              class="checkbox"
              name="confirm"
              (change)="setStandardRolesOfCustomer($event)"
              formControlName="confirmed"> {{ 'confirmed' | translate }}
          </label>
          <label for="emailVerified">
            <input
              id="emailVerified"
              type="checkbox"
              class="checkbox"
              name="emailVerified"
              formControlName="emailVerified"> {{ 'Email verified' | translate }}
          </label>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{ 'Title' | translate }}
        </label>
        <div class="input-container" fxFlex="70">
          <ng-select
            [items]="getListOfSalutations()"
            bindLabel="label"
            bindValue="value"
            [searchable]="false"
            [clearable]="true"
            placeholder="{{'Please select...' | translate}}"
            notFoundText="{{'No results found' | translate}}"
            formControlName="salutation">
          </ng-select>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="firstName" class="control-label" fxFlex="30">
          {{ 'First name' | translate }} *
        </label>
        <div class="input-container" fxFlex="70">
          <input
            type="text"
            class="form-control"
            id="firstName"
            maxlength="20"
            formControlName="firstName">
          <div
            *ngIf="userForm.controls['firstName'].errors && (userForm.controls['firstName'].dirty || userForm.controls['firstName'].touched)">
            <small [hidden]="!userForm.controls['firstName'].errors.required" class="feedback">
              {{ 'Required' | translate }}
            </small>
            <small [hidden]="!userForm.controls['firstName'].errors.minlength" class="feedback">
              {{ 'It should be at least 2 characters long' | translate }}
            </small>
            <small [hidden]="!userForm.controls['firstName'].errors.maxlength" class="feedback">
              {{ 'Maximum length is 20 characters' | translate }}
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="lastName" class="control-label" fxFlex="30">
          {{ 'Last name' | translate }} *
        </label>
        <div class="input-container" fxFlex="70">
          <input
            type="text"
            class="form-control"
            id="lastName"
            maxlength="40"
            formControlName="lastName">
          <div
            *ngIf="userForm.controls['lastName'].errors && (userForm.controls['lastName'].dirty || userForm.controls['lastName'].touched)">
            <small [hidden]="!userForm.controls['lastName'].errors.required" class="feedback">
              {{ 'Required' | translate }}
            </small>
            <small [hidden]="!userForm.controls['lastName'].errors.minlength" class="feedback">
              {{ 'It should be at least 2 characters long' | translate }}
            </small>
            <small [hidden]="!userForm.controls['lastName'].errors.maxlength" class="feedback">
              {{ 'Maximum length is 40 characters' | translate }}
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="email" class="control-label" fxFlex="30">
          {{ 'E-mail' | translate }} *
        </label>
        <div class="input-container" fxFlex="70">
          <input
            class="form-control"
            id="email"
            maxlength="50"
            formControlName="email">
          <div
            *ngIf="userForm.controls['email'].errors && (userForm.controls['email'].dirty || userForm.controls['email'].touched)">
            <small [hidden]="!userForm.controls['email'].errors.required" class="feedback">
              {{ 'Required' | translate }}
            </small>
            <small [hidden]="!userForm.controls['email'].errors.pattern" class="feedback">
              {{ 'Email must have the format john.doe@example.com' | translate }}
            </small>
            <small [hidden]="!userForm.controls['email'].errors.maxlength" class="feedback">
              {{ 'Maximum length is 50 characters' | translate }}
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="phone" class="control-label" fxFlex="30">
          {{ 'Phone number' | translate }}
          <span *ngIf="getPhoneNumberRequired()">*</span>
        </label>
        <div class="input-container" fxFlex="70">
          <input
            type="text"
            class="form-control"
            id="phone"
            maxlength="20"
            formControlName="phone">
          <div
            *ngIf="userForm.controls['phone'].errors && (userForm.controls['phone'].dirty || userForm.controls['phone'].touched)">
            <small [hidden]="!userForm.controls['phone'].errors.pattern" class="feedback">
              {{ 'Please enter a valid phone number' | translate }}
            </small>
            <small [hidden]="!userForm.controls['phone'].errors.maxlength" class="feedback">
              {{ 'Maximum length is 20 characters' | translate }}
            </small>
            <small [hidden]="!userForm.controls['phone'].errors.required" class="feedback">
              {{ 'Required' | translate }}
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="birthDate" class="control-label" fxFlex="30">
          {{ 'Date of birth' | translate }}
        </label>
        <div class="input-container" fxFlex="70">
          <date-picker-input
            [formGroup]="userForm"
            formControlName="birthDate"
            ngDefaultControl
            id="birthDate">
          </date-picker-input>
          <div
            *ngIf="userForm.controls['birthDate'].errors && (userForm.controls['birthDate'].dirty || userForm.controls['birthDate'].touched)">
            <small class="feedback" [hidden]="!userForm.controls['birthDate'].errors.ngbDate">
              {{ 'Date format must be yyyy-mm-dd' | translate }}.
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="postalCode" class="control-label" fxFlex="30">
          {{ 'PostalCode' | translate }}
          <span *ngIf="postalCodeRequired">*</span>
        </label>
        <div class="input-container" fxFlex="70">
          <input
            type="text"
            class="form-control"
            id="postalCode"
            maxlength="10"
            formControlName="postalCode">

          <div
            *ngIf="userForm.controls['postalCode'].errors && (userForm.controls['postalCode'].dirty || userForm.controls['postalCode'].touched)">
            <small [hidden]="!userForm.controls['postalCode'].errors.required" class="feedback">
              {{ 'Required' | translate }}.
            </small>
            <small [hidden]="!userForm.controls['postalCode'].errors.pattern" class="feedback">
              {{ 'PostalCode format not valid' | translate }}.
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{ 'Country' | translate }} *
        </label>
        <div class="input-container" fxFlex="70">
          <ng-select
            [items]="getListOfCountries()"
            bindLabel="label"
            bindValue="value"
            [searchable]="false"
            [clearable]="false"
            placeholder="{{'Please select...' | translate}}"
            notFoundText="{{'No results found' | translate}}"
            formControlName="countryCode">
          </ng-select>
          <div
            *ngIf="userForm.controls['countryCode'].errors && (userForm.controls['countryCode'].dirty || userForm.controls['countryCode'].touched)">
            <small [hidden]="!userForm.controls['countryCode'].errors.required" class="feedback">
              {{ 'Required' | translate }}.
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{ 'Language' | translate }} *
        </label>
        <div class="input-container" fxFlex="70">
          <ng-select
            [items]="getListOfLanguages()"
            bindLabel="label"
            bindValue="value"
            [searchable]="false"
            [clearable]="false"
            placeholder="{{'Please select...' | translate}}"
            notFoundText="{{'No results found' | translate}}"
            formControlName="language">
          </ng-select>
          <div
            *ngIf="userForm.controls['language'].errors && (userForm.controls['language'].dirty || userForm.controls['language'].touched)">
            <small [hidden]="!userForm.controls['language'].errors.required" class="feedback">
              {{ 'Required' | translate }}.
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{ 'Authorizations' | translate }}
        </label>
        <div class="input-container disabled" fxFlex="70">
          <ng-select
            [items]="getRoleOptions()"
            bindLabel="label"
            bindValue="value"
            [multiple]="true"
            [clearable]="true"
            [closeOnSelect]="false"
            formControlName="selectedRoles"
          ></ng-select>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <span class="control-label" fxFlex="30"></span>
        <div fxLayout="column" fxFlex="70">
          <label for="customerAdmin">
            <input
              type="checkbox"
              class="checkbox"
              name="customerAdmin"
              id="customerAdmin"
              formControlName="customerAdmin"> {{ 'Customer admin' | translate }}
          </label>
        </div>
      </div>

      @if (!isUserReadonly()) {
        <div fxLayout="column" fxLayoutGap="10px">
          <div class="bottom-actions" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
            <div fxFlex="45" fxFlex.xs="100" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">

              <div fxLayout fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="space-around center" fxLayoutGap="10px"
                   class="btn-container">
                <button class="btn btn-success save-btn" type="submit"
                        [disabled]="!userForm.valid">
                <span>
                @if (isCreateMode()) {
                  {{ 'Save user' | translate }}
                } @else {
                  {{ 'Update user' | translate }}
                }
                </span>
                </button>
              </div>

              @if (isEditMode()) {
                <div fxLayout fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="space-around center" fxLayoutGap="10px"
                     class="btn-container">
                  <div class="delete-btn-container">
                    <app-delete-modal
                      [whichPage]="'details'"
                      [firstName]="getCurrentUser().firstName"
                      [lastName]="getCurrentUser().lastName"
                      [disabled]="!!getCurrentUser()?.crmContactId"
                      [disabledTooltip]="'User with CRM ID cannot be deleted' | translate"
                      (onHide)="deleteUser($event)">
                    </app-delete-modal>
                  </div>
                </div>
              }

            </div>
          </div>
        </div>
      }

    </form>
  </div>
</div>
<div class="divider"></div>
